// src/redux/thunks/orgThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";

// Thunk for fetching orgs
export const fetchOrgs = createAsyncThunk(
  "org/fetchOrgs",
  async (query, { rejectWithValue }) => {
    try {
      const res = await fetch(
        `https://v3.dhundhoo.com/superAdmin/search/get/org/${query}`
      );
      if (!res.ok) throw new Error("Failed to fetch orgs");
      const data = await res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);
